import {ChangeDetectionStrategy, Component, Inject, Input} from "@angular/core";
import {AviaResultRoutLeg} from "../../../../services/router/interfaces/avia-search";
import {pluralize} from "../../../../components/pipes/pluralize/pluralize";
import {DurationPipe} from "../../../../services/router/pipes/duration.pipe";
import {TimePipe} from "../../../../services/router/pipes/time.pipe";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {APP_CONFIG, AppConfig} from "../../../../config/app.config";

@Component({
  selector: 'app-avia-card-fly',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './avia-card-fly.component.html',
  styleUrl: './avia-card-fly.component.scss',
  imports: [
    DurationPipe,
    TimePipe
  ],
  standalone: true
})
export class AviaCardFlyComponent {
  @Input() leg: AviaResultRoutLeg;

  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private sanitizer: DomSanitizer) {
  }

  translations = this.appConfig.translates.aviaListing;

  ngOnInit(): void {

  }

  get stopovers() {
    if (this.leg.numberOfStopovers > 0) {
      const str = pluralize(this.leg.numberOfStopovers, this.translations.pluralLayover);

      const iataCodes = this.leg.stopovers
        .map(stopover => stopover.location.airport.iataCode)
        .join(', ');

      return `${this.leg.numberOfStopovers} ${str} ${iataCodes}`;
    }

    return this.translations.withoutLayover;
  }

  getAirlineLogo(iataCode: string): SafeResourceUrl {
    const url = `/x-assets/img/airlines/round/${iataCode}.png`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  get uniqueSegments() {
    const seen = new Set<string>();

    return (this.leg?.segments || []).filter((segment) => {
      const code = segment.airline?.iataCode;

      if (!code) {
        return true;
      }

      if (seen.has(code)) {
        return false;
      }

      seen.add(code);
      return true;
    });
  }
}
